import { studentAlertKey } from "../helper/constants";
import { getApi } from "./apiBase";
import { student_alert } from "./apiURL";


class StudentalertService {
    constructor() {
        this.academicAlerts=[];
        this.studentAlert=[];
        this.alertsData=[];
        this.businessAlerts=[];
        this.ferpaWarnings=[];    
    }

    checkAlertFlag(studentId) {
        let studentIdStorage = sessionStorage.getItem(studentAlertKey);                             
        return studentIdStorage == studentId;
    }

    setAlertFlag(studentId) {
        sessionStorage.setItem(studentAlertKey, studentId);                             
    }

    clearAlertFlag() {
        sessionStorage.setItem(studentAlertKey,null);                             
    }

    getAlerts(selectedStudent) {
        
        if(!this.checkAlertFlag(selectedStudent.studentID)) {
            this.clearAlertFlag();
            return getApi(`${student_alert}/${selectedStudent.studentUID}`).then((resp) => {            
                const canViewStudent = this.setAlertsData(resp.data.data);
                if ( canViewStudent) {
                    return{
                        alertsData: this.alertsData,
                        open: true,
                        studentName: this.studentAlert[0]["firstName"] ? this.studentAlert[0]["lastName"] + ", " + this.studentAlert[0]["firstName"] : "",
                    }                    
                } 
                return{
                    open: false,
                }                    
            }).catch((err) => {
                console.log(err);                
                return new Promise(resolve => {
                    resolve({
                        open: false
                    })
                });                    
            })            
        } else {
            return new Promise(resolve => {
                resolve({
                    open: false
                })
            });                    
        }
    }

    setAlertsData(alertsData) {
        this.academicAlerts = alertsData.academicAlerts;
        this.studentAlert = alertsData.studentAlert;
        this.alertsData = alertsData;
        this.businessAlerts = alertsData.businessAlerts;
        this.ferpaWarnings = alertsData.ferpaWarnings;
        if (this.academicAlerts.length > 0 || this.businessAlerts.length > 0 || this.ferpaWarnings.length > 0) 
            return true;
        else 
            return false;
    }
}

export default new StudentalertService();